import { useQuery } from '@tanstack/react-query';
import { useSuiClient } from '@mysten/dapp-kit';
import { QueryKeys } from '@/consts';
import { vipRepository } from '@/repositories/vip-repository';

export const useVipMultipliers = () => {
	const client = useSuiClient();

	return useQuery({
		queryKey: [QueryKeys.VipExpMultipliers],
		queryFn: () => vipRepository.getExpMultipliers(client),
		staleTime: 60_000,
	});
};
